var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_769_5552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 2.4987C3.11199 2.4987 2.90003 2.5865 2.74375 2.74278C2.58747 2.89906 2.49967 3.11102 2.49967 3.33203V10.832C2.49967 11.053 2.58747 11.265 2.74375 11.4213C2.90003 11.5776 3.11199 11.6654 3.33301 11.6654H4.16634C4.62658 11.6654 4.99967 12.0385 4.99967 12.4987C4.99967 12.9589 4.62658 13.332 4.16634 13.332H3.33301C2.66997 13.332 2.03408 13.0686 1.56524 12.5998C1.0964 12.131 0.833008 11.4951 0.833008 10.832V3.33203C0.833008 2.66899 1.0964 2.03311 1.56524 1.56426C2.03408 1.09542 2.66997 0.832031 3.33301 0.832031H10.833C11.496 0.832031 12.1319 1.09542 12.6008 1.56426C13.0696 2.0331 13.333 2.66899 13.333 3.33203V4.16536C13.333 4.6256 12.9599 4.9987 12.4997 4.9987C12.0394 4.9987 11.6663 4.6256 11.6663 4.16536V3.33203C11.6663 3.11102 11.5785 2.89906 11.4223 2.74278C11.266 2.5865 11.054 2.4987 10.833 2.4987H3.33301ZM9.16633 8.33202C8.70609 8.33202 8.33299 8.70511 8.33299 9.16535V16.6653C8.33299 17.1256 8.70609 17.4987 9.16633 17.4987H16.6663C17.1266 17.4987 17.4997 17.1256 17.4997 16.6653V9.16535C17.4997 8.70511 17.1266 8.33202 16.6663 8.33202H9.16633ZM6.66633 9.16535C6.66633 7.78464 7.78562 6.66535 9.16633 6.66535H16.6663C18.047 6.66535 19.1663 7.78464 19.1663 9.16535V16.6653C19.1663 18.0461 18.047 19.1653 16.6663 19.1653H9.16633C7.78562 19.1653 6.66633 18.0461 6.66633 16.6653V9.16535Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_5552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.afb571e76b3a211f2fb822395b0d2cd3.svg";
export { ForwardRef as ReactComponent };